import { format as dateFnsFormat } from 'date-fns';
import { LocaleDateFormat } from 'models/locale-format';
import { getCurrentLocaleFormat } from './get-locale-format';

export type DateVariant = 'datetime' | 'date' | 'time';

export const getDateFormatPattern = (format: LocaleDateFormat, variant: DateVariant): string => {
    switch (format) {
        case LocaleDateFormat.ISO:
            return variant === 'datetime' ? 'yyyy-MM-dd HH:mm' : variant === 'date' ? 'yyyy-MM-dd' : 'HH:mm';
        case LocaleDateFormat.CENTRAL_EUROPE:
            return variant === 'datetime' ? 'dd.MM.yyyy HH:mm' : variant === 'date' ? 'dd.MM.yyyy' : 'HH:mm';
        case LocaleDateFormat.WESTERN_EUROPE:
            return variant === 'datetime' ? 'dd/MM/yyyy HH:mm' : variant === 'date' ? 'dd/MM/yyyy' : 'HH:mm';
        case LocaleDateFormat.US:
            return variant === 'datetime' ? 'MM/dd/yyyy h:mm a' : variant === 'date' ? 'MM/dd/yyyy' : 'h:mm a';
        default:
            return 'yyyy-MM-dd HH:mm';
    }
};

export const formatDate = (
    date: Date | number | string | null | undefined,
    variant: DateVariant = 'datetime',
    formatOverride?: LocaleDateFormat,
): string => {
    if (date === null || date === undefined || date === '') return '';
    const d = typeof date === 'string' || typeof date === 'number' ? new Date(date) : date;
    if (Number.isNaN(d.getTime())) return '';
    const fmt = formatOverride ?? getCurrentLocaleFormat().date;
    return dateFnsFormat(d, getDateFormatPattern(fmt, variant));
};

export const getDatePickerFormat = (variant: DateVariant = 'date'): string =>
    getDateFormatPattern(getCurrentLocaleFormat().date, variant);
